// inputFormat.js — operasyonel giriş formatları, TEK KAYNAK (iOS karşılığı: TextFormat.swift).
//
// up: operasyonel serbest metin girişleri BÜYÜK HARF (Türkçe karakter ASCII'ye çevrilir).
//     Login ve admin hesap formları HARİÇ; select'lere UYGULANMAZ (değerleri UUID taşır).
//
// normTime: SAAT girişleri yazarken otomatik "2000" → "20:00" (23/59 kısıtlı).
//     SÜRE alanları (388:10 gibi 24h üstü değerler, FTL baseline) bu formatı KULLANMAZ.

const TR_MAP = { 'ç':'c', 'Ç':'C', 'ğ':'g', 'Ğ':'G', 'ı':'i', 'İ':'I', 'ö':'o', 'Ö':'O', 'ş':'s', 'Ş':'S', 'ü':'u', 'Ü':'U' };

// trAscii: Turkce harfleri ASCII karsiligiyla degistirir, BUYUK/kucuk KORUNUR.
//     `up`in yarisi; ayri durmasinin sebebi PDF tarafi (18 Eyl 2026):
//     rapor Helvetica/Courier ile cizilir, bu fontlar WinAnsi kodlamasini
//     kullanir ve **ğ ı ş İ** o kodlamada YOKTUR — pdf-lib fırlatir, rapor
//     hic uretilmez. Rapor govdesi buyuk harfe cevrilemeyecegi icin (uzun
//     metinler var) yalnizca ASCII'lestiren bir adim gerekti.
//     Harita TEK: `up` de bunu kullanir, ikinci bir liste yoktur.
export const trAscii = (v) =>
  String(v ?? '').replace(/[çÇğĞıİöÖşŞüÜ]/g, (ch) => TR_MAP[ch]);

// up: RAPOR YOLU. ASCII'ye katlar + BUYUK harf.
// ⚠️ BURADAKI KATLAMA KALDIRILAMAZ (18 Eyl 2026): `report-pdf.ts` bunu cizim
//    aninda cagiriyor ve rapor Helvetica/Courier ile ciziliyor; o fontlar
//    WinAnsi kullanir, `ğ ı ş İ` o kodlamada YOKTUR ve pdf-lib FIRLATIR.
//    Uc ucus tam bu yuzden raporsuz arsivlenmisti. Giris yolu artik Turkce
//    harfi zaten KABUL ETMIYOR (asagidaki `gecersizHarfler`), ama eski
//    kayitlar ve disaridan gelen dosya adlari hala buradan geciyor —
//    katlama son savunma hatti olarak DURUR.
export const up = (v) => trAscii(v).toUpperCase();

// ─────────────────────────────────────────────────────────────────────────
// GIRIS KAPISI — YALNIZ A–Z (20 Eyl 2026)
// ─────────────────────────────────────────────────────────────────────────
// 🔑 Serkan: *"Uygulamanin hicbir yerinde Ingilizce disinda karakter
//    girilemesin, girildiginde alanin altinda kirmizi uyari ciksin,
//    kaydettirmesin."* Sorup teyit ettik: ISTISNA YOK — gerekce/rapor
//    kutulari zaten Ingilizce yaziliyor, meydanlarin Ingilizce adi var, isim
//    alanlari da dahil (*"ingilizce karakter orada da zorunlu olsun"*).
//
// KAPSAM: yalnizca HARFLER. Rakam, noktalama, bosluk, sembol serbest —
// operasyonel metinde hepsi gerekli (`LTAC/LTFE`, `3.5T`, `+3`).
//
// 🔴 ESKI DAVRANIS: `up()` girise de uygulaniyordu ve `s` -> `S` diye
//    SESSIZCE ceviriyordu. Yazan kisi ne oldugunu gormuyordu; SKPK gerekcesi
//    `TAKDIRIYLE` olarak kaydediliyor, kimse soylemiyordu (Ilke 2).
//
// ⚠️ HARF DUSURULMEZ, DEGISIKLIK REDDEDILIR. `ÇANKAYA` yapistirilinca `Ç`yi
//    atip `ANKAYA` yazmak sessiz veri bozmadir; onun yerine yapistirmanin
//    TAMAMI reddedilir ve hangi harflerin kabul edilmedigi soylenir.

const HARF = /\p{L}/u;

/** Degerdeki A–Z disi HARFLER (tekrarsiz, gorulme sirasinda). */
export const gecersizHarfler = (v) => {
  const bulunan = [];
  for (const ch of String(v ?? '')) {
    if (HARF.test(ch) && !/[A-Za-z]/.test(ch) && !bulunan.includes(ch)) bulunan.push(ch);
  }
  return bulunan;
};

// upEvent: up() uygular ve İMLECİ YERİNDE BIRAKIR. onChange'de
//     `up(e.target.value)` YERİNE bunu kullan.
//
// 🔴 NEDEN VAR (7 Eyl 2026, Serkan: "araya bir madde yazmaya calisiyorum,
//    tek harf yazinca en sona atliyor" — LTCW risk anketi remark kutusu):
//    Alan kontrollü. Metnin ORTASINA küçük harf yazınca up() değeri
//    değiştirir, React kutuyu baştan yazar, tarayıcı da imleci SONA koyar.
//    Büyük harf yazınca değer değişmediği için zıplamaz — hatanın bu kadar
//    geç fark edilmesinin sebebi bu.
//
// ÇÖZÜM: DOM'un değerini React'ten ÖNCE eşitle ve imleci elle geri koy.
//    React commit ettiğinde kutuda zaten doğru değer durur, dokunmaz, imleç
//    kaymaz. Senkron — setTimeout/requestAnimationFrame YOK, titreme yok.
//    up() harfi harfe eşler (ı→I, ğ→G) yani indeks birebir aynı kalır;
//    beklenmedik bir uzunluk farkında imleç eski davranışa (sona) düşer,
//    yani hiçbir koşulda BOZULMAZ, en kötü ihtimalle eskisi gibi olur.
export const upEvent = (e) => {
  const el = e && e.target;
  const ham = el ? String(el.value ?? '') : '';
  const v = up(ham);
  if (el && v !== ham && v.length === ham.length) {
    try {
      const bas = el.selectionStart, son = el.selectionEnd;
      if (bas != null) { el.value = v; el.setSelectionRange(bas, son); }
    } catch { /* number/email gibi seçim desteklemeyen tipler: değer doğru, imleç korunmaz */ }
  }
  return v;
};

export const normTime = (v) => {
  const d = String(v ?? '').replace(/[^\d]/g, '').slice(0, 4);
  if (d.length <= 2) return d;
  let hh = d.slice(0, 2), mm = d.slice(2);
  if (Number(hh) > 23) hh = '23';
  if (mm.length === 2 && Number(mm) > 59) mm = '59';
  return `${hh}:${mm}`;
};

// normDuration: SÜRE girişleri (blok / uçuş süresi). Serkan (6 Ağu): "düz rakam
//     bile yazsam HH:MM üretmesi gerekirdi" — maskenin işi bu, kullanıcı iki
//     nokta aramamalı.
//     normTime'dan FARKI RAKAM YORUMU: normTime ilk iki haneyi SAAT sayar
//     (saat-of-day geleneği), o yüzden "308" → "23:8" gibi çöp üretir. Sürede
//     SON İKİ HANE DAKİKADIR: "308" → 3:08, "0308" → 3:08, "1230" → 12:30.
//     TAVAN 23:59 (Serkan, 6 Ağu: "bizim uçaklar zaten o kadar uçmuyor") —
//     tek bacağın blok süresi 24 saati aşmaz; aşan bir değer giriş hatasıdır.
// ── UTC FARKI MASKESI (21 Eyl 2026) ─────────────────────────────────
// Tanimsiz meydan beyaninda girilen `+03:00` / `-05:30`. Maske BURAYA yazilir,
// bilesenin icine degil: saat/sure maskeleri zaten tek dosyada duruyor ve
// ikinci bir kopya er ya da gec ayrisirdi (Ilke 3).
// 🔑 Yarim saatlik dilimler GERCEKTIR (+05:30 Hindistan · +04:30 Afganistan ·
//    +12:45 Chatham) — dakika serbest birakilir, saate yuvarlanmaz.
export const normOffset = (v) => {
  const ham = String(v ?? '');
  const isaret = ham.trim().startsWith('-') ? '-' : '+';
  const d = ham.replace(/[^\d]/g, '').slice(0, 4);
  if (!d) return ham.trim() === '-' ? '-' : '';
  if (d.length <= 2) return `${isaret}${d}`;
  let hh = d.slice(0, 2), mm = d.slice(2);
  if (Number(hh) > 14) hh = '14';
  if (mm.length === 2 && Number(mm) > 59) mm = '59';
  return `${isaret}${hh}:${mm}`;
};

export const normDuration = (v) => {
  const d = String(v ?? '').replace(/[^\d]/g, '').slice(0, 4);
  if (d.length <= 2) return d;
  let hh = String(Number(d.slice(0, d.length - 2)));   // bastaki sifirlar atilir
  let mm = d.slice(-2);
  if (Number(hh) > 23) hh = '23';
  if (Number(mm) > 59) mm = '59';
  return `${hh}:${mm}`;
};

// ── TOPLAM SÜRE HHHH:MM (2 Eki 2026) — uçak / motor saati ─────────────
// `normDuration` GÜNLÜK süredir (saati 23'te keser); uçak gövdesi ve motor binlerce saattir. Yalnız rakam, en çok
// 6 hane saat + 2 hane dakika. "4100:30" de "410030" da → "4100:30".
// 🔑 Serkan (3 Eki 2026): *"sadece 5 yazarsam 5 dk, 535 yazarsam 5 saat 35 dk olmalı"* — rakamlar SAĞDAN dizilir: son iki
//    hane dakika, öndekiler saat ("5" → "0:05", "535" → "5:35"); her tuşta aynı kural, yani yazdıkça kayar.
// 🔴 ÖNCESİ: dakika 59'a KIRPILIYORDU ve bir-iki rakam olduğu gibi kalıyordu. Yazarken "386" → "3:59" oluyor, sonraki
//    rakamlar bozuk değerin üstüne ekleniyordu — "3864:30" GİRİLEMİYORDU; "5" kayıtta geçersiz sayılıyordu.
//    Dakika artık kırpılmaz: 60–99 görünür kalır ve kayıt reddeder (`saatDkCoz` → null) — uydurma düzeltme yok.
export const normToplamSure = (v) => {
  const d = String(v ?? '').replace(/[^\d]/g, '').replace(/^0+(?=\d)/, '').slice(0, 8);
  if (!d) return '';
  const p = d.padStart(3, '0');
  return `${Number(p.slice(0, -2))}:${p.slice(-2)}`;
};

// ── LMC METNI — RAPORUN IKI YUZU AYNI BICIMI BASAR (22 Eyl 2026) ──────
// iPad LMC'yi lb VE kg olarak birlikte tutar; isaret +/− dugmesinden gelir
// ve raporda da GORUNUR yazilir. Rapor PDF'i (`report-pdf.ts`) ve web'in
// yedek rapor gorunumu (`FlightReport.js`) bu fonksiyonu cagirir — bicim tek
// yerde (Ilke 3). Deger yoksa null: yer tutucuyu (`-` / `—`) cagiran secer.
export const lmcMetni = (lmc) => {
  const isaretli = (v, birim) => {
    const s = String(v ?? '').trim();
    if (!s || s === '-') return null;
    return (s.startsWith('-') ? s : '+' + s) + ' ' + birim;
  };
  const parca = [isaretli(lmc?.lb, 'lb'), isaretli(lmc?.kg, 'kg')].filter(Boolean);
  return parca.length ? parca.join(' / ') : null;
};

// ── BİRİMSİZ VERİ OLMAZ (12 Eki 2026, Serkan) ───────────────────────────
// 🔑 *"Birimsiz veri olmaz"* · sürat kt · ağırlık lb · pist ft · QNH hPa (*"hPa olacak"*) · saat UTC · süre h — birimler
//    iPad'in giriş ekranındakilerle aynı. Rapor PDF'i (`report-pdf.ts`) ve web'in yedek rapor görünümü (`FlightReport.js`)
//    bu iki fonksiyonu çağırır — biçim tek yerde. `bos`: boş değerin yer tutucusu (PDF `-`, web `—`); boşa birim yapışmaz.
/** Değer + birim. `binlik`: tam sayı binlik ayırıcıyla (12467 → 12,467). Değer birimi zaten taşıyorsa ikinci kez eklenmez;
 *  derece (°) boşluksuz yapışır. */
export function birimli(v, birim, { binlik = false, bos = '—' } = {}) {
  if (v === null || v === undefined) return bos;
  const s = String(v).trim();
  if (s === '' || s === '-' || s === '—') return bos;
  if (s.toLowerCase().endsWith(birim.toLowerCase())) return s;
  const n = s.replace(/,/g, '');
  const deger = binlik && /^-?\d+$/.test(n) ? Number(n).toLocaleString('en-US') : s;
  return birim === '°' ? `${deger}°` : `${deger} ${birim}`;
}
// ── RAPOR AĞIRLIKLARI: PLAN + LMC CORRECTED (31 Eki 2026, Serkan — G7) ──────────────────
// 🔑 *"LMC yapılsa da yapılmasa da TOW / LW / ZFW END FLT raporunda görünsün"* · karar **B**: `PLAN TOW · ZFW · LW` satırı her
//    zaman (şirkette LMC kapalı olsa da); LMC yapılmışsa altına `LMC CORRECTED TOW · ZFW · LW`. Değerleri iPad T/O kaydında
//    yazar (`LMCHesap.raporAgirliklari` — OFP'yi yalnız iPad okur, tek kaynak); rapor kaydedileni AYNEN basar, hesap yapmaz.
//    · PLAN satırı yalnız değer KAYDEDİLMİŞSE: boş metin = OFP'de yok → hücre çizgi; hiç kaydedilmemişse (Build 77 öncesi
//      uçuş, sütun NULL) satır HİÇ basılmaz (Serkan 31 Eki: *"A: hiç basılmasın"*).
//    · LMC CORRECTED satırı en az bir değer doluysa (iPad LMC yoksa boş yazar).
// Rapor PDF'i ve web'in yedek görünümü bunu çağırır; biçimi (`birimli`, lb, binlik) çağıran verir. Satır yoksa null.
/** @returns {{ plan: {lbl: string, deger: *}[], lmc: {lbl: string, deger: *}[] | null } | null} */
export const raporAgirlikSatirlari = (ag) => {
  const anahtarlar = [['TOW', 'tow'], ['ZFW', 'zfw'], ['LW', 'lw']];
  const kayitli = (o) => !!o && anahtarlar.some(([, k]) => o[k] !== null && o[k] !== undefined);
  const dolu = (o) => !!o && anahtarlar.some(([, k]) => String(o[k] ?? '').trim() !== '');
  if (!kayitli(ag?.plan)) return null;
  const satir = (o, on) => anahtarlar.map(([ad, k]) => ({ lbl: `${on} ${ad}`, deger: o?.[k] ?? null }));
  return { plan: satir(ag.plan, 'PLAN'), lmc: dolu(ag.lmc) ? satir(ag.lmc, 'LMC CORRECTED') : null };
};
// ── ALTERNATE WXR (31 Eki 2026, Serkan — G8) ─────────────────────────────────────────────────────────────────────────────
// 🔑 *"END FLT'de ALT WXR ve/veya fotosu olmalı"* → raporda ne girildiyse o: YAZI girildiyse LANDING altında
//    `ALTN WXR <ayraç> <ICAO>` satırı, foto ek sayfa (`ATTACHMENT - ALTN WXR`). Yazı yoksa (yalnız foto, ya da planda ALT
//    yok, ya da Build 77 öncesi uçuş) satır HİÇ basılmaz. ICAO'yu iPad yazar (planın ALT'ı, divert değiştirmez).
// Rapor PDF'i ve web'in yedek görünümü bunu çağırır; ayracı çağıran verir (PDF "-", web "—" — başlıklarıyla aynı).
// İki alan AÇIKÇA verilir (`ld.altn_icao, ld.altn_wxr`) — sunucunun kapsam nöbetçisi raporun okuduğu alanı böyle görür.
/** @returns {{ icao: string, metin: string } | null} */
export const altnWxrSatiri = (altnIcao, altnWxr) => {
  const metin = String(altnWxr ?? '').trim();
  if (!metin) return null;
  return { icao: String(altnIcao ?? '').trim().toUpperCase(), metin };
};

/** Süre: dakika sayısı ya da "HH:MM" → "HH:MM h" (dakika 24 saati aşarsa saat sayısı büyür, gün devri yok). */
export function sureMetni(v, { bos = '—' } = {}) {
  if (v === null || v === undefined) return bos;
  const s = String(v).trim();
  if (s === '' || s === '-' || s === '—') return bos;
  if (/^-?\d+$/.test(s)) {
    const m = Math.abs(Number(s));
    return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')} h`;
  }
  return birimli(s, 'h', { bos });
}

// ── NET LMC (12 Eki 2026, Serkan) ──────────────────────────────────────
// 🔑 FUEL ve PAYLOAD LMC ayrı girilir; OM sınırı NET toplama (*"yakıt veya yük fark etmez"*): NET = FUEL + PAYLOAD.
// Rapor PDF'i ve web yedek görünümü bu fonksiyonu çağırır. İkisi de boşsa null; kg yalnız girilen her tarafın kg'ı
// varsa yazılır (eksik kg sayıyı yarım bırakmasın).
export const lmcNetMetni = (fuel, payload) => {
  const n = (v) => {
    const s = String(v ?? '').trim();
    if (!s || s === '-') return null;
    const x = parseInt(s, 10);
    return Number.isFinite(x) ? x : null;
  };
  const fl = n(fuel?.lb), pl = n(payload?.lb);
  if (fl === null && pl === null) return null;
  const fk = n(fuel?.kg), pk = n(payload?.kg);
  const isaretli = (v) => (v > 0 ? '+' : '') + v;
  const kgVar = (fl === null || fk !== null) && (pl === null || pk !== null);
  return isaretli((fl ?? 0) + (pl ?? 0)) + ' lb' + (kgVar ? ' / ' + isaretli((fk ?? 0) + (pk ?? 0)) + ' kg' : '');
};

// ── SATIR BASI `-` (22 Eyl 2026, Serkan) ────────────────────────────────
// 🔑 *"Yazma hücresi `-` ile başlasa, enter'la alt satıra inerken `-`
//    otomatik gelse mümkün mü?"* (RAAQ anketinin serbest metni → SECTION 4)
// Saf fonksiyon: imleç hesabı ekranda değil burada, testle çivilenir.
// İşaretler yalnız YAZIM KOLAYLIĞIDIR; kaydederken soyulur (generatePpsBriefing).
export function tireliYeniSatir(v, bas, son) {
  const m = String(v ?? '');
  const a = Math.max(0, Math.min(bas ?? m.length, m.length));
  const b = Math.max(a, Math.min(son ?? a, m.length));
  return { metin: m.slice(0, a) + '\n- ' + m.slice(b), imlec: a + 3 };
}

